import React from "react";
import { Form, Input } from "antd";
import EditableTableContext from "./EditableTableContext";
import PriceFormInput from "../PriceFormInput";

interface Props<T = any> extends React.HTMLAttributes<HTMLElement> {
  editMode?: boolean;
  editable: boolean;
  dataIndex: string;
  title: string;
  inputType: "number" | "text";
  record: T;
  index: number;
  children: React.ReactNode;
  handleSave?: (record: T) => void;
}

const EditableCell: React.FC<Props> = ({
  editable,
  editMode = false,
  dataIndex,
  title,
  inputType,
  record,
  children,
  handleSave,

  ...restProps
}) => {
  const form = React.useContext(EditableTableContext);

  /**
   * Handles record saving
   */
  const save = async () => {
    try {
      if (form) {
        const values = await form.validateFields();

        handleSave && handleSave({ ...record, ...values });
      }
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  /**
   * Make sure field is populated with default value
   */
  React.useEffect(() => {
    if (form && dataIndex && record) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  }, [editMode, form, dataIndex, record]);

  const inputNode =
    inputType === "number" ? (
      <PriceFormInput.PriceInput onPressEnter={save} onBlur={save} />
    ) : (
      <Input onPressEnter={save} onBlur={save} />
    );

  let childNode = children;

  childNode =
    editable && editMode ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        {inputNode}
      </Form.Item>
    ) : (
      <div style={{ paddingRight: 24 }}>{children}</div>
    );

  return <td {...restProps}>{childNode}</td>;
};

export default EditableCell;
